/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.layouts.membership.controllers', [])

.controller('LayoutsMembershipController', ['$scope', function($scope) {

    $scope.layoutsMembership = {

      model: "Your spankin new application.layouts.membership view!",

      init: function() {},

      success: {
        init: function(response) {}
      },

      error: {
        init: function(response) {}
      }

    };

    $scope.layoutsMembership.init();

}]);